import { render, staticRenderFns } from "./OnlineService.vue?vue&type=template&id=35c62cd2&scoped=true"
import script from "./OnlineService.vue?vue&type=script&lang=js"
export * from "./OnlineService.vue?vue&type=script&lang=js"
import style0 from "./OnlineService.vue?vue&type=style&index=0&id=35c62cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c62cd2",
  null
  
)

export default component.exports